"use client";

import React from "react";
import { Trophy, ShieldCheck, Users, Star } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const sectors = [{
  title: "Fair-play",
  description: "Nous cultivons l'esprit sportif, l'entraide et le respect mutuel, piliers essentiels de chaque rencontre signée Kickoff Events.",
  icon: ShieldCheck
}, {
  title: "Organisation Pro",
  description: "Une logistique millimétrée et un encadrement de premier ordre pour garantir à chaque équipe une expérience de tournoi mémorable.",
  icon: Trophy
}, {
  title: "Développement",
  description: "Offrir à chaque joueur un espace d'expression unique pour progresser, s'épanouir et relever de nouveaux défis à son rythme.",
  icon: Star
}, {
  title: "Communauté",
  description: "Rejoignez un réseau dynamique de clubs et de familles unis par l'amour du jeu et le football de demain.",
  icon: Users
}];
export default function PartnersInProgress() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224151" id="pourquoi-nous-rejoindre" className="w-full py-16 md:py-24 lg:py-32 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center justify-center text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground tracking-tight mb-4 uppercase">
            Pourquoi Participer
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-default max-w-3xl">
            Vivez l'intensité du terrain dans un cadre exceptionnel, conçu pour révéler le potentiel de chaque jeune passionné de football.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {sectors.map((sector, i) => {
          const Icon = sector.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full border-t-4 border-t-primary border-x-border border-b-border bg-card transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:border-primary/50 group">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex items-center justify-center rounded-lg bg-primary/10 p-3 w-fit transition-colors duration-300 group-hover:bg-primary/20">
                      <Icon className="size-16 text-primary" strokeWidth={1} />
                    </div>
                    <CardTitle className="text-2xl font-bold font-default text-foreground/90 group-hover:text-foreground transition-colors">
                      {sector.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground font-default leading-relaxed">
                      {sector.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}